export enum TemplateTypeEnum {
    STUDENTS_XLSX = 'STUDENTS_XLSX',
    STUDENTS_TEMPLATE_CSV = 'STUDENTS_TEMPLATE_CSV',
    STUDENTS_CREDITS_XLSX = 'STUDENTS_CREDITS_XLSX',
    STUDENTS_CREDITS_TEMPLATE_XLSX = 'STUDENTS_CREDITS_TEMPLATE_XLSX',
    STUDENTS_TRAINING_DURATION_TEMPLATE_XLSX = 'STUDENTS_TRAINING_DURATION_TEMPLATE_XLSX',
    MILITARY_STUDENTS_XLSX = 'MILITARY_STUDENTS_XLSX',
    ACT_RECONCILIATION_XLSX = 'ACT_RECONCILIATION_XLSX',
    ACT_ACCEPTANCE_XLSX = 'ACT_ACCEPTANCE_XLSX',
    INVOICE_RECONCILIATION_XLSX = 'INVOICE_RECONCILIATION_XLSX'
}
